import { render, staticRenderFns } from "./uber-footer.vue?vue&type=template&id=30610a83&"
var script = {}
import style0 from "./uber-footer.vue?vue&type=style&index=0&id=30610a83&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports